/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

function DialogClose(props) {
  const { t } = useTranslation();
  const { onClose } = props;
  return (
    <>
      {onClose ? (
        <IconButton aria-label={t('actions.close.modal')} data-testid="close-button" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </>
  );
}

DialogClose.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default DialogClose;
